import type { BucketSelection } from "../../types";

export interface PendingDocumentFilter {
    datasourceId: string;
    selection: BucketSelection[];
}

const STORAGE_KEY = "cts-pending-document-filter";

export const setPendingDocumentFilter = (filter: PendingDocumentFilter): void => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(filter));
};

export const peekPendingDocumentFilter = (): PendingDocumentFilter | undefined => {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as PendingDocumentFilter) : undefined;
};

export const takePendingDocumentFilterFor = (
    datasourceId: string | undefined,
): BucketSelection[] | undefined => {
    const pending = peekPendingDocumentFilter();
    if (!pending || !datasourceId || pending.datasourceId !== datasourceId) return undefined;
    sessionStorage.removeItem(STORAGE_KEY);
    return pending.selection;
};
